import { SupportTypes } from "@ks/weblogger/lib/log.browser";
import { userInfo, qualification } from "@/hooks/useUserInfo";
import { weblogger } from "./weblogger";

export interface IRadarCustomParams {
    name: string;
    category?: string;
    src?: string;
    result_type?: string;
    message?: string;
    extra_info?: {
        [key: string]: any;
    };
}

const getCommonParams = () => {
    return {
        ...(qualification.value || {}),
        ...(userInfo.value || {}),
    };
};

export const sendEvent = (type: string, action: string, params: Record<string, any>) => {
    // 固定用npcdm.dwd_pub_tfc_clk_elmt_hi表，避免数据搭建时联表查
    const fixedType = "click" || type;
    const commonParams = getCommonParams();
    const mergeParams = {
        ...commonParams,
        location: decodeURIComponent(window.location.href),
        pathname: window.location.pathname,
        ...params,
    };
    weblogger &&
        weblogger.collect?.(fixedType.toUpperCase() as SupportTypes, {
            action: action.toUpperCase(),
            params: mergeParams,
        });
};

const sendFMP = () => {
    weblogger?.plugins?.radar?.fmp?.();
};

// 页面曝光
export const sendPagePv = (pageName: string, params: object): void => {
    weblogger?.sendImmediately("PV", {
        type: "enter",
        page: pageName, // 设置当前进入页面的页面标识（在埋点平台注册，在 App 分析查看）
        params: params,
    });
};

// 业务在首屏接口请求完毕之后调用该方法进行FMP上报
export function sendFmpAfterFirstScreen() {
    // @ts-ignore
    if (window.requestIdleCallback) {
        // 浏览器空闲期间调用
        requestIdleCallback(sendFMP, { timeout: 1 });
        // @ts-ignore
    } else if (window.requestAnimationFrame) {
        // 浏览器执行动画并请求浏览器在下一次重绘之前调用
        requestAnimationFrame(sendFMP);
    } else {
        setTimeout(sendFMP, 0);
    }
}
